import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import debug from 'debug';
import axiosInstance from '../../../../../shared/utils/axios';
import styled from 'styled-components/macro';
import Tile from '../../../../../shared/components/Tile';
import Page from '../../../../../shared/components/Page';
import DescriptiveText from '../../../../../shared/components/DescriptiveText';
import useQueryString from '../../../../../shared/utils/useQueryString';
import {LoadingSpinner} from '../../../../../shared';

const log = debug('circleblack:redtail');

const _Iframe = styled.iframe`
  height: 1000px;
  width: 100%;
  border: none;
  margin-top: 40px;
  background: url('https://www.wpfaster.org/wp-content/uploads/2013/06/circle-loading-gif.gif') center center no-repeat;
`;
const Redtail = () => {
  log('rendering');
  const [url, setUrl] = useState('');
  const [accountID] = useQueryString('accountID');
  const [householdID] = useQueryString('householdID');
  let query = '';
  if (accountID) {
    query += `accountID=${accountID}`;
  }
  if (householdID) {
    query += `householdID=${householdID}`;
  }
  useEffect(() => {
    axiosInstance.get('/auth/redtail/login' + (query ? '?' + query : ''))
      .then(function success(res) {
        setUrl(res.data);
      });
  }, []);

  return <Page>
    <Tile key='Redtail' title='Redtail'>
      {
        url
          ? <_Iframe seamless={true} src={url}/>
          : <>
            <DescriptiveText>
              Connecting to Redtail...
            </DescriptiveText>
            <LoadingSpinner/>
          </>
      }
    </Tile>
  </Page>;
};

const mapStateToProps = state => ({
  session: state.session,
});

export default connect(mapStateToProps, null)(Redtail);

Redtail.propTypes = {
  /**
   * Is from Session Reducer
   */
  session: PropTypes.shape({profile: PropTypes.object}).isRequired,
};
